import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../Apiurs/Apiurls";
import Navbar from "../Shared/AssociateNavbar/Navbar";
import { AuthContext } from "../AuthContext/Authcontext";
import { Tabs, Tab } from "react-bootstrap";
import CustomQuillEditor from "./CustomQullier";
import "./Email.css";

const EmailHistory = () => {
  const { leadid } = useParams();
  const { userEmail,userId } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { email, quotationData, autoFillSubject, autoFillBody } = location.state || {};
  
  const [emailHistory, setEmailHistory] = useState([]);
  const [text, setText] = useState(autoFillBody || "");
  const [subject, setSubject] = useState(autoFillSubject || "");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const chatEndRef = useRef(null);
  const [collapsed, setCollapsed] = useState(false);
  const [receiverEmails, setReceiverEmails] = useState(email || "");
  const [ccEmails, setCcEmails] = useState("");
  const [bccEmails, setBccEmails] = useState("");
  const [showCC, setShowCC] = useState(false);
  const [showBCC, setShowBCC] = useState(false);
  const [groupedEmailHistory, setGroupedEmailHistory] = useState([]);
  const [isSendingQuotation, setIsSendingQuotation] = useState(false);

  // Auto-fill with quotation data if available
  useEffect(() => {
    if (quotationData && quotationData.pdfFile) {
      setSelectedFiles([quotationData.pdfFile]);
    }
  }, [quotationData]);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const validFiles = files.filter(file => {
      if (file.size > 2 * 1024 * 1024) {
        alert(`File ${file.name} must be below 2MB.`);
        return false;
      }
      return true;
    });
    setSelectedFiles(prev => [...prev, ...validFiles]);
  };

  const removeFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index));
  };


const handleSendEmail = async () => {
  console.log("🚀 handleSendEmail triggered!");

  // ✅ Step 1: Log all main variables
  console.log("Lead ID:", leadid);
  console.log("User Email:", userEmail);
  console.log("Receiver Emails (raw):", receiverEmails);
  console.log("Quotation Data:", quotationData);

  // ✅ Step 2: Validate fields
  if (!text && selectedFiles.length === 0) {
    alert("Please enter a message or upload files.");
    return;
  }

  if (!userEmail) {
    alert("Sender email not found. Please log in again.");
    return;
  }

  const receivers = receiverEmails
    .split(",")
    .map((email) => email.trim())
    .filter(Boolean);
  if (receivers.length === 0) {
    alert("Please enter at least one recipient email.");
    return;
  }

  const cc = showCC
    ? ccEmails.split(",").map((email) => email.trim()).filter(Boolean)
    : [];
  const bcc = showBCC
    ? bccEmails.split(",").map((email) => email.trim()).filter(Boolean)
    : [];

  setLoading(true);
  setIsSendingQuotation(!!quotationData);

  const formData = new FormData();

  // ✅ Step 3: Handle leadid safely
  const safeLeadId =
    leadid ||
    quotationData?.leadId ||
    quotationData?.lead_id ||
    quotationData?.leadinfo?.lead_id ||
    null;

  if (!safeLeadId) {
    console.warn("⚠️ Lead ID is missing! Defaulting to null.");
  } else {
    console.log("✅ Final Lead ID to send:", safeLeadId);
  }

  // ✅ Step 4: Append core data
  formData.append("leadid", safeLeadId);
  formData.append("sender_email", "landnestiiiqbets@gmail.com");
  formData.append("sender", userId);
  formData.append("text", text);
  formData.append(
    "subject",
    subject ||
      (quotationData
        ? `Quotation ${quotationData.quotationNumber} from SBS Company`
        : "New Message")
  );
  formData.append("type", "sent");
  formData.append("is_plain_text", "false");
  formData.append("receiver_emails", JSON.stringify(receivers));
  if (showCC) formData.append("cc_emails", JSON.stringify(cc));
  if (showBCC) formData.append("bcc_emails", JSON.stringify(bcc));

  // ✅ Step 5: Add quotation details (if present)
  if (quotationData) {
    const {
      quotationNumber,
      leadId,
      leadName,
      subtotal,
      totalGST,
      grandTotal,
      discount,
      discountType,
      terms_conditions,
      quotation_body,
      products,
      message_id,
      leadInfo,
      companyInfo,
      regardsInfo,
    } = quotationData;

    console.log("📦 Quotation Products:", products);

    formData.append(
      "quotationData",
      JSON.stringify({
        quotationNumber,
        leadId,
        leadName,
        subtotal,
        totalGST,
        grandTotal,
        discount,
        discountType,
        terms_conditions,
        quotation_body,
        products,
        message_id,
      })
    );

    // ✅ Send extra info
    formData.append("receiver_details", JSON.stringify(leadInfo || {}));
    formData.append("company_details", JSON.stringify(companyInfo || {}));
    formData.append("regard_details", JSON.stringify(regardsInfo || {}));
  }

  // ✅ Step 6: Attach files
  selectedFiles.forEach((file) => {
    formData.append("files", file);
  });

  // ✅ Step 7: Debug FormData before sending
  for (let [key, value] of formData.entries()) {
    console.log(`📤 ${key}:`, value);
  }

  // ✅ Step 8: Send email
  try {
    const response = await axios.post(
      `${baseURL}/api/send-quotation-email`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    console.log("📩 Server Response:", response.data);

    if (response.data.success) {
      alert(
        quotationData
          ? "Quotation email sent successfully!"
          : "Email sent successfully!"
      );

      // ✅ Update quotation status
      if (quotationData && quotationData.leadId) {
        console.log("🔄 Updating quotation status for lead:", quotationData.leadId);
        try {
          await axios.put(
            `${baseURL}/api/update-quotation-status/${quotationData.leadId}`,
            {
              quotation_status: "Sent",
            }
          );
        } catch (statusErr) {
          console.error("Error updating quotation status:", statusErr);
        }
      }

      // ✅ Reset form
      setText("");
      setSubject("");
      setCcEmails("");
      setBccEmails("");
      setSelectedFiles([]);
      navigate(-1);
    } else {
      alert("Failed to send email: " + (response.data.error || "Unknown error"));
    }
  } catch (error) {
    console.error("❌ Error sending email:", error);
    alert("Failed to send email. Please try again.");
  }

  setLoading(false);
  setIsSendingQuotation(false);
};



  const cleanEmailText = (text) => {
    if (!text) return "";
    const cleanedText = text.split(/\n?On\s.+\s(?:at|wrote:)/i)[0];
    return cleanedText.replace(/--\sThis email has been checked for viruses.*/is, "").trim();
  };

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
        <div className="email-content-inner">
          <div className="email-form-section">
            <div className="email-form-card">
              <h3 className="email-form-title">
                {quotationData ? "Send Quotation Email" : "Send Email"}
              </h3>
              
              <div className="email-form-group">
                <label className="email-form-label">To:</label>
                <textarea
                  placeholder="Enter recipient emails (comma separated)"
                  value={receiverEmails}
                  onChange={(e) => setReceiverEmails(e.target.value)}
                  className="email-input-receivers"
                />
              </div>

              <div className="email-cc-bcc-toggle">
                <label className="email-toggle-label">
                  <input
                    type="checkbox"
                    checked={showCC}
                    onChange={() => setShowCC(!showCC)}
                  />
                  Add CC
                </label>
                <label className="email-toggle-label">
                  <input
                    type="checkbox"
                    checked={showBCC}
                    onChange={() => setShowBCC(!showBCC)}
                  />
                  Add BCC
                </label>
              </div>

              {showCC && (
                <div className="email-form-group">
                  <label className="email-form-label">CC:</label>
                  <textarea
                    placeholder="Enter CC emails (comma separated)"
                    value={ccEmails}
                    onChange={(e) => setCcEmails(e.target.value)}
                    className="email-input-receivers"
                  />
                </div>
              )}

              {showBCC && (
                <div className="email-form-group">
                  <label className="email-form-label">BCC:</label>
                  <textarea
                    placeholder="Enter BCC emails (comma separated)"
                    value={bccEmails}
                    onChange={(e) => setBccEmails(e.target.value)}
                    className="email-input-receivers"
                  />
                </div>
              )}

              <div className="email-form-group">
                <label className="email-form-label">Subject:</label>
                <input
                  type="text"
                  placeholder="Enter Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  className="email-input-subject"
                />
              </div>
              
              <div className="email-form-group">
                <label className="email-form-label">Message:</label>
                <CustomQuillEditor
                  value={text}
                  onChange={setText}
                  className="email-rich-text-editor"
                  placeholder="Enter your message here..."
                />
              </div>
              
              <div className="email-form-group">
                <label className="email-form-label">Attachments:</label>
                <input
                  type="file"
                  onChange={handleFileChange}
                  className="email-file-input"
                  multiple
                />
                {selectedFiles.length > 0 && (
                  <div className="selected-files mt-2">
                    <strong>Selected files:</strong>
                    {selectedFiles.map((file, index) => (
                      <div key={index} className="file-item d-flex align-items-center mt-1">
                        <span className="me-2">📎 {file.name}</span>
                        {/* <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeFile(index)}
                        >
                          Remove
                        </button> */}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              
              <button
                onClick={handleSendEmail}
                disabled={loading}
                className={`email-send-button ${quotationData ? 'btn-primary' : ''}`}
              >
                {loading 
                  ? "Sending..." 
                  : (quotationData ? "Send Quotation Email" : "Send Email")
                }
              </button>

              {/* {quotationData && (
                <button
                  onClick={() => navigate(-1)}
                  className="btn btn-outline-secondary mt-2 ms-2"
                >
                  Cancel
                </button>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailHistory;